import { useIntl } from 'react-intl'
import { PageTitle } from '../../../_metronic/layout/core'
import {
  StatisticsWidget5,
} from '../../../_metronic/partials/widgets'
import { useEffect } from 'react'
import { apiCaller } from '../../core/hooks/useApi'
import { ServiceAgent } from '../../core/services/serviceAgent'
import { useLoadingContext } from '../../core/context/loading/loading'
import { useDashboardStore } from '../../core/state-management/states/dashboard'
import { IDashboard } from '../../core/interfaces'
import { ConvenienceFakeData } from '../../core/utils/utility'
import { EtebariBox } from './components/EtebariBox/EtebariBox'
import { DakheliBox } from './components/DakheliBox/DakheliBox'
import { ZemanatBox } from './components/ZemanatBox/ZemanatBox'
import { KarogozaiBox } from './components/KarogozaiBox/KarogozaiBox'
import { KhatarBox } from './components/KhatarBox/KhatarBox'

const DashboardPage = ({ dashboardInfo }: { dashboardInfo: IDashboard | undefined }) => (
  <>
    {/* begin::Row */}
    <div className='row g-5 g-xl-8'>
      <div className='col-xl-3'>
        <StatisticsWidget5
          className='card-xl-stretch mb-xl-8'
          svgIcon='document'
          color='body-white'
          iconColor='primary'
          title='تسهیلات'
          description={ConvenienceFakeData.filter(item => !item.title.includes('بیشتر')).map(item => item.title).toString()}
          titleColor='gray-900'
          descriptionColor='gray-400'
          value={dashboardInfo?.totalTashilat || 0}
        />
      </div>

      <div className='col-xl-3'>
        <StatisticsWidget5
          className='card-xl-stretch mb-xl-8'
          svgIcon='timer'
          color='primary'
          iconColor='white'
          title='درجریان'
          description='وضعیت درخواست هایی که در جریان هستند'
          titleColor='white'
          descriptionColor='white'
          value={dashboardInfo?.pending || 0}
        />
      </div>

      <div className='col-xl-3'>
        <StatisticsWidget5
          className='card-xl-stretch mb-5 mb-xl-8'
          svgIcon='element-11'
          color='dark'
          iconColor='gray-100'
          title='تکمیل شده'
          description='درخواست های تکمیل شده'
          titleColor='gray-100'
          descriptionColor='gray-100'
          value={dashboardInfo?.complete || 0}
        />
      </div>
      <div className='col-xl-3'>
        <StatisticsWidget5
          className='card-xl-stretch mb-5 mb-xl-8'
          svgIcon='tablet-delete'
          color='danger'
          iconColor='white'
          title='عودت داده شده'
          description='درخواست های عودت داده شده'
          titleColor='white'
          descriptionColor='white'
          value={dashboardInfo?.reject || 0}
        />
      </div>
    </div>
    {/* end::Row */}

    {/* begin::Row */}
    <div className='row gy-5 g-xl-8'>
      {
        dashboardInfo &&
        <>
          <div className='col-xl-4'>
            <EtebariBox title='خط اعتباری' className='card-xl-stretch mb-xl-8' />
          </div>
          <div className='col-xl-4'>
            <DakheliBox title='منابع داخلی' className='card-xl-stretch mb-xl-8' />
          </div>
          <div className='col-xl-4'>
            <ZemanatBox title='ضمانت نامه' className='card-xl-stretch mb-xl-8' />
          </div>
          <div className='col-xl-4'>
            <KarogozaiBox title='کارگزاری' className='card-xl-stretch mb-xl-8' />
          </div>
          <div className='col-xl-4'>
            <KhatarBox title='سرمایه گذاری خطر پذیر' className='card-xl-stretch mb-xl-8' />
          </div>
        </>
      }

    </div>
    {/* end::Row */}
  </>
)

const DashboardWrapper = () => {
  const intl = useIntl();
  const { handleClose, handleOpen } = useLoadingContext();

  ///states
  const { dispatch, state } = useDashboardStore()

  const getDashBoardInfo = () => {
    apiCaller({
      api: ServiceAgent.dashboard.request_getpaneldashboard,
      onSuccess(resp) {
        if (resp?.status === 200 && resp?.data?.statusCode === 200) {
          dispatch({
            payload: { dashboardValues: resp?.data.data },
            type: 'SET_DASHBOARD_DEATIL_DATA'
          })
        }
      },
      onStart: handleOpen,
      onEnd: handleClose
    })
  }
  useEffect(() => {
    getDashBoardInfo()
  }, []);


  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.DASHBOARD' })}</PageTitle>
      <DashboardPage dashboardInfo={state.dashboardValues} />
    </>
  )
}

export { DashboardWrapper }
